<template>
    <div class="container">
        <div class="holder">
            <div class="car"></div>
            <div class="wheels"></div>
            <div class="wind-holder">
                <div class="wind"></div>
            </div>
            <div class="tree tree1"></div>
            <div class="tree tree2"></div>
            <div class="tree tree3"></div>
            <div class="hill hill1"></div>
            <div class="hill hill2"></div>
            <div class="cloud cloud1"></div>
            <div class="cloud cloud1-2"></div>
            <div class="cloud cloud2"></div>
            <div class="cloud cloud2-2"></div>
            <div class="text-center">
                <h1 class="text-primary">Procesando</h1>
            </div>
        </div>
    </div>
</template>

<script>
    import * as servicio from "../servicios";
    export default {
        name: "app",
        data:()=>({
            formulario:{
                agencia:{id:null},
                orden:null,
                datos:{},
            },
            query:null,
            parametros:{
                agencia:null,
                orden:null,
            },
            vin:null,
        }),
        methods:{
            buscarAutos:function(){
                if(this.parametros.agencia && this.parametros.orden){
                    const objeto = {
                        orden:this.parametros.orden,
                        agencia:{
                            id:this.parametros.agencia
                        }
                    };
                    servicio.orden.consultar(objeto).then(response=>{
                        if(response.data)
                            this.resultadoEncontrado(objeto,response.data);
                        else
                            this.casoError();
                    }).catch(()=>{
                        this.casoError();
                    });
                }else if(this.query){
                    const objeto = {
                        orden:Array.isArray(this.query.ordenT) ? this.query.ordenT[0] : this.query.ordenT,
                        vin:Array.isArray(this.query.vin) ? this.query.vin[0] : this.query.vin,
                        sucursal:Array.isArray(this.query.sucursal) ? this.query.sucursal[0] : this.query.sucursal,
                        taller:Array.isArray(this.query.taller) ? this.query.taller[0] : this.query.taller,
                    };
                    servicio.orden.consultarApp(objeto).then(response=>{
                        if(response.data)
                            this.resultadoEncontrado(objeto,response.data);
                        else
                            this.casoError();
                    }).catch(()=>{
                        this.casoError();
                    });
                }
            },
            resultadoEncontrado:function(objeto,response){
                this.formulario.orden=objeto.orden;
                this.formulario.datos=response;
                this.formulario.agencia.id=objeto.agencia ? objeto.agencia.id : null;
                this.$store.commit('setPaso',{data:this.formulario,p:1});
                this.$store.commit('setActual', 2);
                this.$router.push({ name: 'p2' });
            },
            casoError:function(){
                this.$store.commit('setActual', 1);
                this.$router.push({ name: 'Home' });
            }
        },
        mounted(){
            setTimeout(() => {
                this.buscarAutos();
            }, 3000);
        },
        created(){
            this.query= this.$route.query;
            this.parametros = this.$route.params;
            this.$store.commit('setActual', null);
        }
    }
</script>

<style scoped>
    .container{
        padding-bottom: 500px;
    }


</style>
